import { useGlobalConfigsContext } from 'contexts';
import {
  NewBasketWizard,
  NewBasketContextProvider
} from 'features/shared-baskets';
import { Navigate } from 'react-router-dom';

export function CreateBasketRoute() {
  const { promoShop } = useGlobalConfigsContext();

  if (!promoShop?.id) {
    return <Navigate to="/" replace />;
  }

  return (
    <NewBasketContextProvider>
      <NewBasketWizard />
    </NewBasketContextProvider>
  );
}
